/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'chevron': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M12.469 31.219c-1.27 0-2.414.773-2.894 1.95a3.134 3.134 0 0 0 .714 3.417l37.5 37.5a3.13 3.13 0 0 0 4.422 0l37.5-37.5c.602-.582.95-1.383.957-2.223a3.13 3.13 0 0 0-5.379-2.2L50 67.454 14.711 32.164a3.13 3.13 0 0 0-2.242-.945z"/>'
  }
})
